import Box from '@material-ui/core/Box';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import SubmitButton from '../Button/SubmitButton';

export type ForcefulDialogProps = {
    open: boolean,
    setOpen: any,
    disableBgClick: boolean,
    title: string,
    description: string,
    onSubmit: any,
    submitMessage: string
}

const useStyles = makeStyles({
	dialogTitle: {
		textAlign: 'center'
	},
	dialogDescription: {
		textAlign: 'center',
		padding: '0px 0px 30px'
	}
});

const ForcefulDialog = (props: ForcefulDialogProps) => {
    const classes = useStyles();

	const handleClose = () => {
		props.setOpen(false);
	};

	return (
		<Dialog
			open={props.open}
			// TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-labelledby='alert-dialog-slide-title'
			aria-describedby='alert-dialog-slide-description'
			maxWidth='xs'
			fullWidth
			disableBackdropClick={props.disableBgClick}
		>
			<DialogTitle
				className={classes.dialogTitle}
				id='alert-dialog-slide-title'
			>
				{props.title}
			</DialogTitle>
			<DialogContent className={classes.dialogDescription}>
				{/* <DialogContentText id='alert-dialog-slide-description'> */}
				{props.description}
				{/* </DialogContentText> */}
			</DialogContent>
			<DialogActions>
				<Box margin='10px auto 20px'>
					<SubmitButton icon={''} onClick={props.onSubmit} message={props.submitMessage} />
				</Box>
			</DialogActions>
		</Dialog>
	);
};

export default ForcefulDialog;